import { CameraPosition, Circle, GoogleMap, GoogleMapsEvent, HtmlInfoWindow, ILatLng, Marker, MyLocation, MyLocationOptions, Polygon } from '@ionic-native/google-maps';
import { CircleOptions } from './circle-options';
import { PolygonOptions } from './polygon-options';
import { PolygonUtil } from './polygon-util';

export class MapWrapper {

    private infoWindow: HtmlInfoWindow;

    constructor(private map: GoogleMap) {
    }

    getMapObject(): GoogleMap {
        return this.map;
    }

    addPolygon(polygonPoints: ILatLng[], options?: PolygonOptions): Polygon {

        let hasConfig = false;
        if (options) hasConfig = true

        let polygon = this.map.addPolygonSync({
            points: polygonPoints,
            strokeColor: hasConfig ? options.borderColor || '#ffffff' : '#ffffff',
            fillColor: hasConfig ? options.fillColor || 'rgba(102, 170, 170, 0.5)' : 'rgba(102, 170, 170, 0.5)',
            strokeWidth: 3,
            clickable: hasConfig ? options.clickable : false
        });

        if (options && options.onclick) {
            polygon.on(GoogleMapsEvent.POLYGON_CLICK).subscribe((param) => {
                this.closeTooltip();
                if (options.contentTooltip) {
                    let centerPolygon: ILatLng = PolygonUtil.findPolygonCenter(param[1]);
                    this.openTooltip(options.contentTooltip, centerPolygon);
                }
                options.onclick(param[0], param[1]);
            });
        }

        return polygon;
    }

    addMarker(centerPolygon: ILatLng): Marker {
        return this.map.addMarkerSync({
            icon: {
                url: './assets/imgs/marker-new.png'
            },
            visible: false,
            position: centerPolygon,
            infoWindowAnchor: [33, 87]
        });
    }

    addCircle(options: CircleOptions): Circle {
        const circle = this.map.addCircleSync({
            center: options.center,
            radius: options.radius,
            strokeColor: options.borderColor ? options.borderColor : '#ffffff',
            strokeWidth: options.borderWidth ? options.borderWidth : 3,
            fillColor: options.fillColor ? options.fillColor : 'rgba(102, 170, 170, 0.5)',
            clickable: options.clickable ? options.clickable : false
        });

        if (options.onclick) {
            circle.on(GoogleMapsEvent.CIRCLE_CLICK).subscribe((param) => {
                this.closeTooltip();

                if (options.contentTooltip) {
                    this.openTooltip(options.contentTooltip, param[1].getCenter());
                }

                options.onclick(param[0], param[1]);
            });
        }

        return circle;
    }

    openTooltip(contents: string, position: ILatLng) {
        let markerInfo = this.addMarker(position);

        this.moveCamera({
            target: position,
            duration: 100
        });

        this.infoWindow = new HtmlInfoWindow();
        this.infoWindow.setBackgroundColor('#ddd');
        this.infoWindow.setContent(contents);
        this.infoWindow.open(markerInfo);
    }

    closeTooltip() {
        if (this.infoWindow) {
            this.infoWindow.close();
            this.infoWindow = null;
        }
    }

    destroyMap() {
        if (this.map)
            this.map.remove();
    }

    clearMap() {
        if (this.map)
            this.map.clear();
    }

    setCenter(position) {
        if (this.map)
            this.map.setCameraTarget(position)
    }

    async moveCamera(cameraPosition: CameraPosition<any>): Promise<any> {
        if (this.map) {
            if (cameraPosition.duration) {
                return this.map.animateCamera(cameraPosition);
            } else {
                return this.map.moveCamera(cameraPosition);
            }
        }
    }

    async getMyLocation(options?: MyLocationOptions): Promise<MyLocation> {
        return this.map.getMyLocation({ enableHighAccuracy: true });
    }
}